"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonReducer = exports.setNavBarCollapsed = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    isNavbarCollapsed: false,
};
var commonSlice = (0, toolkit_1.createSlice)({
    name: "commonSlice",
    initialState: initialState,
    reducers: {
        setNavBarCollapsed: function (state, action) {
            var isNavbarCollapsed = action.payload;
            state.isNavbarCollapsed = isNavbarCollapsed;
        },
    },
});
exports.setNavBarCollapsed = commonSlice.actions.setNavBarCollapsed;
exports.commonReducer = commonSlice.reducer;
